import { createAsyncTypes } from 'utils/ActionCreator'

export const GENERAL_SETTINGS_REQUEST_ASYNC = createAsyncTypes(
  'GENERAL_SETTINGS_REQUEST',
  'Settings/ProfileSettings/ShowSettings'
)
export const UPDATE_GENERAL_SETTINGS_REQUEST = createAsyncTypes(
  'UPDATE_GENERAL_SETTINGS_REQUEST',
  'Settings/ProfileSettings/ShowSettings'
)
export const UPDATE_PASSWORD_REQUEST = createAsyncTypes(
  'UPDATE_PASSWORD_REQUEST',
  'Settings/ProfileSettings'
)
